import { Inject, Injectable } from '@angular/core';
import { TInputAppEnvironmentVars } from '@monorepo/types';

const ComponentLineInEndPoints = {
  SAVE_COMPONENT_TAGS: 'SAVE_COMPONENT_TAGS',
  FETCH_TRANSACTION_LOG: 'FETCH_TRANSACTION_LOG',
  TRANSACTION_DETAILS: 'TRANSACTION_DETAILS',
  UNDO_COMPONENT_TAGS: 'UNDO_COMPONENT_TAGS',
};

type TComponentLineInEndPoints = typeof ComponentLineInEndPoints;
type TComponentLineInEndPointsTypes = keyof TComponentLineInEndPoints;
type TEnvVariables = TComponentLineInEndPoints;

@Injectable({
  providedIn: 'root',
})
export class ComponentLineInEnvProvider {
  private env_vars!: TEnvVariables;
  private protocol = 'http';
  private service_host = '';
  private bulk_count_app_services = '';

  constructor(@Inject('environment') ENV: TInputAppEnvironmentVars) {
    if (ENV.protocol != null) {
      this.protocol = ENV.protocol;
    }
    if (ENV.service_host != null) {
      this.service_host = ENV.service_host;
    }

    if (ENV.bulk_count_app_services != null) {
      this.bulk_count_app_services = ENV.bulk_count_app_services;
    }

    this.registerVars();
  }

  registerVars() {
    const HOST_DOMAIN_WITH_PROTOCOL = this.protocol + this.service_host;

    this.env_vars = {
      SAVE_COMPONENT_TAGS: HOST_DOMAIN_WITH_PROTOCOL + this.bulk_count_app_services + '/api/v1/lineIn/bulk/add',
      FETCH_TRANSACTION_LOG:
        HOST_DOMAIN_WITH_PROTOCOL + this.bulk_count_app_services + '/api/v1/lineIn/componentTag/transactions',
      TRANSACTION_DETAILS:
        HOST_DOMAIN_WITH_PROTOCOL + this.bulk_count_app_services + '/api/v1/lineIn/componentTag/details',
      UNDO_COMPONENT_TAGS: HOST_DOMAIN_WITH_PROTOCOL + this.bulk_count_app_services + '/api/v1/lineIn/undo',
    };
  }

  getEnvVar(key: TComponentLineInEndPointsTypes): string {
    return this.env_vars[key];
  }
}
